import { Box, Stack, Typography } from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import React from 'react';
import { formatPrice } from '@/utils/formatPrice';
import {
	OrderProgressShippingCostFrameSx,
	OrderProgressShippingCostIconSx,
	OrderProgressShippingCostProgressBarFrameSx,
	OrderProgressShippingCostProgressBarSx,
	OrderProgressShippingCostTextEmphasisSx,
	OrderProgressShippingCostTextSx,
} from '@/components/content/Cart/parts/OrderProgressShippingCost/styles/main';
import { useSingleSettings } from '@/data/Settings';

export const DEFAULT_SHIPPING_MIN = 999;

export const OrderProgressShippingCost = ({
	grandTotal,
	shippingPrice,
}: {
	grandTotal: string | number;
	shippingPrice?: string | number;
}) => {
	const { settings } = useSingleSettings();

	const grandTotalNumber = parseFloat(grandTotal.toString());

	if (!settings || grandTotalNumber <= 0) {
		return null;
	}

	const defaultShippingMin = settings?.userData['com.monto.minimo.eg'] ?? DEFAULT_SHIPPING_MIN;

	const shippingCost = defaultShippingMin - grandTotalNumber + Number(shippingPrice);
	const percentage = (grandTotalNumber / defaultShippingMin) * 100;

	if (percentage >= 100) {
		return null;
	}
	return (
		<Box sx={OrderProgressShippingCostFrameSx}>
			<Stack direction="row" gap={1} alignItems="center">
				<LocalShippingIcon sx={OrderProgressShippingCostIconSx} />
				<Typography component="span" sx={OrderProgressShippingCostTextSx}>
					{'Añade '}
					<Typography component="span" sx={OrderProgressShippingCostTextEmphasisSx}>
						{formatPrice('es-MX', 'MXN', shippingCost)}
					</Typography>{' '}
					{' más para conseguir '}
					<Typography component="span" sx={OrderProgressShippingCostTextEmphasisSx}>
						{'Envío gratis'}
					</Typography>
				</Typography>
			</Stack>
			<Box sx={OrderProgressShippingCostProgressBarFrameSx}>
				<Box sx={OrderProgressShippingCostProgressBarSx(percentage)} />
			</Box>
		</Box>
	);
};
